export default __webpack_public_path__ + "static/media/logo-uefa.76f5ec63.png";